import React, { useEffect, useState } from 'react'
import { Ionicons, Feather } from '@expo/vector-icons'
import { Text, View, Image, Dimensions, Button, TouchableOpacity as RNTouchableOpacity, Platform } from 'react-native'
import * as Progress from 'react-native-progress'
import styles from './MyAdvanceStyles'
import theme from '../../../theme'
import { avatarPlaceholder } from '../customUtils/Constants'
import { colorFilled, colorUnfilled } from '../../../themeConstants'
import { ScrollView } from 'react-native-gesture-handler'

// Usar TouchableOpacity nativo en web, del wrapper en mobile
const TouchableOpacity = Platform.OS === 'web' ? RNTouchableOpacity : RNTouchableOpacity
import {
    AdvanceAchievement,
    AdvanceExam,
    AdvanceMyPoints,
    AdvanceWatchedContent,
    MyAdvanceModel,
    MyAdvanceSingleModel,
    MyTeamAdvance,
} from './models/MyAdvanceModel'
import { Loader } from '../customUtils/Components/Loader'
import { LinealTabs } from '../customUtils/LinealTabs'
import { DateFormatter } from '../customUtils/DateFormatter'
import { FlashList } from '@shopify/flash-list'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { MyTeamAdvanceScreen } from './MyTeamAdvance'
import { fetchAuthSession } from 'aws-amplify/auth'
import { getConection } from '../appBar/context/HeaderContext'
import { request_get_advanced_team } from '../../services/advance.services'
import { getLanguage } from '../appBar/context/LocalizationContext'

const { width } = Dimensions.get('window')

export const MyAdvance = () => {
    const [loading, setLoading] = useState<boolean>(true)
    const [myAdvance, setMyAdvance] = useState<MyAdvanceModel>(null)
    const [myTeam, setMyTeam] = useState<MyTeamAdvance>(null)
    const [tabs, setTabs] = useState([])
    const [selectedIndex, setSelectedIndex] = useState(-2)
    const [updateDate, setUpdateDate] = useState('')
    const { isConnected, hasInternet } = getConection()
    const { languageFile } = getLanguage()

    useEffect(() => {
        fetchData()
    }, [])

    const route = {
        params: {
            regions: myTeam?.regions,
            updateDate: updateDate,
        },
    }

    const fetchData = async () => {
        try {
            if (isConnected && hasInternet) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                const data: MyAdvanceSingleModel = await request_get_advanced_team({ authToken })
                //const data = singleAdvance
                console.log('Advance Data:', data)
                if (!data) {
                    return setSelectedIndex(-1)
                }
                let newTabs = []
                if (data.my_advance) {
                    let advanceTab = { name: 'Mi Avance', index: 0 }
                    setMyAdvance(data.my_advance)
                    newTabs.push(advanceTab)
                }
                if (data.my_team_advance) {
                    let teamTab = { name: 'Mi Equipo', index: 1 }
                    setMyTeam(data.my_team_advance)
                    newTabs.push(teamTab)
                }

                if (newTabs.length > 0) {
                    setSelectedIndex(newTabs[0].index)
                    setTabs(newTabs)
                }

                //@Fixme validar si la fecha es invalida
                let date = DateFormatter({ date: data.date })
                setUpdateDate(date)
            }
        } catch {
            setSelectedIndex(-1)
        } finally {
            setLoading(false)
        }
    }
    if (loading) {
        return <Loader />
    }
    return (
        <View style={styles.container}>
            {tabs.length > 1 && (
                <LinealTabs
                    tabs={tabs}
                    selectedIndex={selectedIndex}
                    color={theme.colors.textSecondary}
                    colorSelected={theme.colors.colorPrimary}
                    onSelectedTab={(i) => {
                        setSelectedIndex(i)
                    }}
                />
            )}

            {(() => {
                switch (selectedIndex) {
                    case 0:
                        return <MyAdvanceScreen myAdvance={myAdvance} updateDate={updateDate} />
                    case 1:
                        return <MyTeamAdvanceScreen route={route} />
                    default:
                        return (
                            <View style={{ height: '100%', justifyContent: 'center' }}>
                                <Image source={require('../../../assets/advance/noDataEvaluations.png')} style={styles.noDataEvaluations} />

                                <Text style={[styles.noDataText, { marginTop: 8, marginBottom: 16 }]}>No hay información</Text>

                                    {Platform.OS === 'web' ? (
                                        <View style={{ padding: 24, alignItems: 'center' }}>
                                            <Text style={{ fontSize: 18, color: 'red' }}>Funcionalidad no disponible en web</Text>
                                        </View>
                                    ) : (
                                        <TouchableOpacity
                                            style={styles.mainButton}
                                            onPress={() => {
                                                setLoading(true)
                                                setSelectedIndex(-2)
                                                fetchData()
                                            }}
                                        >
                                            <Text style={styles.mainButtonText}>{languageFile.retry}</Text>
                                        </TouchableOpacity>
                                    )}
                            </View>
                        )
                }
            })()}
        </View>
    )
}

export const MyAdvanceScreen = ({ myAdvance, updateDate }: { myAdvance: MyAdvanceModel; updateDate: string }) => {
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const onClickCertificate = (url: string) => {
        navigation.navigate('WebView', { link: url } as undefined)
    }
    return (
        <ScrollView showsVerticalScrollIndicator={false} nestedScrollEnabled={true} style={{ backgroundColor: 'white' }}>
            <AdvanceSection myAdvance={myAdvance} />
            {myAdvance?.my_achievements && myAdvance.my_achievements.length > 0 && (
                <AchievementsSection
                    achievement={myAdvance.my_achievements[0]}
                    level={myAdvance.level}
                    name={myAdvance.name}
                    onClickCertificate={onClickCertificate}
                />
            )}
            {myAdvance.my_exams && myAdvance.my_exams.length > 0 && (
                <ExamsSection exams={myAdvance.my_exams} onClickCertificate={onClickCertificate} />
            )}

            {myAdvance.my_points && <PointsSection points={myAdvance.my_points} />}
            <Text style={[styles.infoText, styles.alignCenter, { marginBottom: 16 }]}>{'Última actualización: ' + updateDate}</Text>
        </ScrollView>
    )
}
export const TitleWithDrawable = ({ title }: { title: string }) => {
    return (
        <View style={[styles.containerHeader, styles.marginHorizontal, { marginBottom: 8 }]}>
            <Ionicons name='trending-up-outline' size={20} color={theme.colors.textPrimary} />
            <Text style={[styles.section, styles.marginLeft]}>{title}</Text>
        </View>
    )
}
export const AdvanceSection = ({ myAdvance }: { myAdvance: MyAdvanceModel }) => {
    return (
        <View style={{ backgroundColor: 'white', marginTop: 16 }}>
            <TitleWithDrawable title='Mi avance' />
            <View style={styles.containerSection}>
                {myAdvance.avatar != '' ? (
                    <Image source={{ uri: myAdvance.avatar ?? avatarPlaceholder }} style={styles.avatar} />
                ) : (
                    <Image source={{ uri: avatarPlaceholder }} style={styles.avatar} />
                )}
                <View style={styles.marginHorizontal}>
                    {myAdvance.level && <Text style={styles.titleSection}>{myAdvance.level ?? ''}</Text>}
                    {myAdvance.name && <Text style={styles.subtitleSection}>{myAdvance.name ?? ''}</Text>}
                    {myAdvance.role && <Text style={styles.descriptionSection}>{myAdvance.role ?? ''}</Text>}
                </View>
            </View>
            {myAdvance.watched_content && <ViewedContent watchedContent={myAdvance.watched_content} />}
        </View>
    )
}

export const ViewedContent = ({ watchedContent }: { watchedContent: AdvanceWatchedContent }) => {
    const totalWatched = watchedContent.total ?? 0

    const getColor = (name: string) => {
        switch (name.toLowerCase()) {
            case 'índice salesbook':
                return theme.colors.colorPrimary
            case 'teórica':
                return theme.colors.colorInProgress
            case 'práctica':
                return theme.colors.colorApproved
            default:
                return theme.colors.textPrimary
        }
    }

    let initialSize = 230
    let sizeDifference = 50

    return (
        <View style={styles.containerProgress}>
            <View style={{ flex: 1 }}>
                <Text style={[styles.titleProgressBar, { marginBottom: 8, marginTop: 16 }]}>Contenido visto</Text>
                <Progress.Bar
                    progress={totalWatched / 100}
                    height={12}
                    width={width - 24}
                    style={styles.progressBar}
                    color={colorFilled}
                    unfilledColor={colorUnfilled}
                />
                {totalWatched > 0 ? (
                    <View style={{ flex: 1 }}>
                        {watchedContent.detail && watchedContent.detail.length > 0 && (
                            <View>
                                <View
                                    style={{
                                        flex: 1,
                                        position: 'relative',
                                        height: initialSize,
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginVertical: 20,
                                    }}
                                >
                                    {watchedContent.detail.map((detail, index) => {
                                        let color = getColor(detail.name)

                                        let size = initialSize - index * sizeDifference
                                        let total = detail.total ?? 0

                                        return <CircularProgressView key={index} color={color} progress={total} size={size} />
                                    })}
                                    <Text style={styles.percentage}>{(watchedContent.indice_salesbook ?? 100) + '%'}</Text>
                                </View>
                                <View style={[styles.containerRow, { marginBottom: 15 }]}>
                                    {watchedContent.detail.map((detail, index) => {
                                        let color = getColor(detail.name)
                                        return (
                                            <>
                                                <View style={[styles.reference, { backgroundColor: color }]}></View>
                                                <Text style={styles.subtitleSection}>{detail.name}</Text>
                                            </>
                                        )
                                    })}
                                </View>
                            </View>
                        )}
                    </View>
                ) : (
                    <View>
                        <Image
                            source={require('../../../assets/advance/noDataProgress.png')}
                            style={[styles.noDataProgress, { marginTop: 16, marginBottom: 8 }]}
                        />

                        <Text style={[styles.noDataText, { marginBottom: 4 }]}>No hay datos suficientes para mostrar tus indicadores</Text>
                    </View>
                )}
            </View>
        </View>
    )
}
const CircularProgressView = ({ progress, color, size }: { progress: number; color: string; size: number }) => {
    return (
        <Progress.Circle
            size={size}
            progress={progress / 100}
            showsText={false}
            thickness={10}
            color={color}
            unfilledColor={theme.colors.disabled}
            borderWidth={0.1}
            borderColor={color}
            strokeCap='round'
            style={{ position: 'absolute', width: size, height: size, flex: 1 }}
        />
    )
}
export const AchievementsSection = ({
    achievement,
    level,
    name,
    onClickCertificate,
}: {
    achievement: AdvanceAchievement
    level: string
    name: string
    onClickCertificate: (url: string) => void
}) => {
    return (
        <>
            <TitleWithDrawable title='Mis logros' />
            <View style={[styles.containerSection, { marginBottom: 16 }]}>
                <Image source={require('../../../assets/advance/myAdvanceCup.png')} style={styles.avatar} />
                <View style={styles.marginHorizontal}>
                    <Text style={[styles.titleSection, { marginBottom: 2 }]}>{level}</Text>
                    <Text style={[styles.subtitleSection, { marginBottom: 2 }]}>{name}</Text>
                    {achievement.download_url && (
                        <TouchableOpacity style={styles.containerRow} onPress={() => onClickCertificate(achievement.download_url)}>
                            <Text style={styles.descriptionSection}>{'CERTIFICADO'}</Text>
                            <Ionicons name='eye' size={16} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                        </TouchableOpacity>
                    )}
                </View>
            </View>
        </>
    )
}

export const ExamsSection = ({ exams, onClickCertificate }: { exams: AdvanceExam[]; onClickCertificate: (url: string) => void }) => {
    return exams.length > 0 ? (
        <View style={{ paddingBottom: 20 }}>
            <TitleWithDrawable title='Exámenes' />

            <View style={[styles.containerRow, styles.paddingHorizontal, { marginBottom: 4 }]}>
                <Text style={[styles.subtitleModule, { flex: 4 }]}>CURSO</Text>
                <Text style={[styles.subtitleModule, { flex: 1 }]}>INT.</Text>
                <Text style={[styles.subtitleModule, { flex: 1 }]}>CALIF.</Text>
            </View>
            <FlashList
                data={exams}
                horizontal={false}
                keyExtractor={(item, index) => index.toString()}
                showsHorizontalScrollIndicator={false}
                renderItem={({ item: benefitItem }) => <ExamItem exam={benefitItem} onClickCertificate={onClickCertificate} />}
            />
        </View>
    ) : (
        <View>
            <TitleWithDrawable title='Exámenes' />
            <Image source={require('../../../assets/advance/noDataEvaluations.png')} style={styles.noDataEvaluations} />

            <Text style={[styles.noDataText, { marginTop: 8, marginBottom: 16 }]}>No tienes resultados de evaluación</Text>
        </View>
    )
}
export const ExamItem = ({ exam, onClickCertificate }: { exam: AdvanceExam; onClickCertificate: (url: string) => void }) => {
    return (
        <View style={styles.containerSection}>
            <View style={{ flex: 5 }}>
                <Text style={styles.myExamsSection} numberOfLines={1} ellipsizeMode='tail'>
                    {exam.name}
                </Text>

                {exam.download_url && (
                    <TouchableOpacity style={styles.containerRow} onPress={() => onClickCertificate(exam.download_url)}>
                        <Text style={styles.descriptionSection}>CERTIFICADO</Text>
                        <Ionicons name='eye' size={16} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                    </TouchableOpacity>
                )}
            </View>

            <View style={[styles.containerDataSection, { flex: 0.5 }]}>
                <Text style={styles.subtitleModule}>{exam.attempts ?? 0}</Text>
            </View>

            <View style={[styles.containerDataSection, { flex: 1 }]}>
                <Text style={[styles.subtitleModule, { color: exam.approved ? theme.colors.colorApproved : theme.colors.colorDisapproved }]}>
                    {(exam.score ?? 0) + '%'}
                </Text>
            </View>
        </View>
    )
}

export const PointsSection = ({ points }: { points: AdvanceMyPoints }) => {
    return (
        <>
            <TitleWithDrawable title='Mis puntos' />
            <View style={styles.containerSection}>
                {points.level && (
                    <View style={styles.containerDataSection}>
                        <Text style={styles.myPointsSection}>Nivel</Text>
                        <Text style={styles.descriptionSection}>{points.level ?? ''}</Text>
                    </View>
                )}

                {points.ranking && (
                    <View style={styles.containerDataSection}>
                        <Text style={styles.myPointsSection}>Ranking</Text>
                        <Text style={styles.descriptionSection}>{points.ranking ?? ''}°</Text>
                    </View>
                )}

                <View style={styles.containerDataSection}>
                    <Text style={styles.myPointsSection}>Puntos</Text>
                    <Text style={styles.descriptionSection}>{points.points ?? '0'}</Text>
                </View>
            </View>
        </>
    )
}

const singleAdvance: MyAdvanceSingleModel = {
    my_advance: {
        name: 'Orav Dev',
        avatar: 'https://cdn-icons-png.flaticon.com/512/6858/6858504.png',
        level: '+999',
        watched_content: {
            total: 60.4,
            indice_salesbook: 60,
            detail: [
                {
                    name: 'Índice Salesbook',
                    total: 77.5,
                },
                {
                    name: 'Teórica',
                    total: 22.4,
                },
                {
                    name: 'Práctica',
                    total: 90.2,
                },
            ],
        },
        my_achievements: [
            {
                name: 'Curso Sarasa',
                description: 'Digamos q completaste el curso',
                download_url: 'https://cdn-icons-png.flaticon.com/512/6858/6858504.png',
            },
        ],
        my_exams: [
            {
                name: 'Curso Sarasa',
                score: 60,
                approved: true,
                attempts: 72,
                download_url: 'https://cdn-icons-png.flaticon.com/512/6858/6858504.png',
            },
            {
                name: 'Curso Sarasa 2',
                score: 25,
                approved: false,
                attempts: 134,
            },
        ],
        my_points: {
            level: 'Pro',
            ranking: 1,
            points: 999,
        },
        role: 'Senior sarasa',
        engagement: 0,
    },
    date: '2024-09-14T20:06:58.738Z',
    my_team_advance: {
        regions: [
            {
                _id: 'region1',
                name: 'Region 1',
                ranking: 1,
                watched_content: 100.0,
                knowledge: 60.5,
                knowledge_technical: 90.0,
                knowledge_practical: 92.0,
                team: [
                    {
                        _id: 'team1',
                        name: 'Team Member 1',
                        level: '5',
                        avatar: 'https://example.com/team1-avatar.jpg',
                        watched_content: 20.0,
                        knowledge: 85.0,
                        knowledge_technical: 82.0,
                        knowledge_practical: 83.0,
                        role: 'Leader',
                    },
                ],
                engagement: 90.0,
            },
            {
                _id: 'region2',
                name: 'Region2',
                ranking: 2,
                watched_content: 100.0,
                knowledge: 60.5,
                knowledge_technical: 90.0,
                knowledge_practical: 92.0,
                team: [
                    {
                        _id: 'team2',
                        name: 'Team Member 1 r2',
                        level: '5',
                        avatar: 'https://example.com/team1-avatar.jpg',
                        watched_content: 20.0,
                        knowledge: 85.0,
                        knowledge_technical: 82.0,
                        knowledge_practical: 83.0,
                        role: 'Leader',
                    },
                ],
                engagement: 90.0,
            },
        ],
    },
}
